import { Inject, Injectable } from "@angular/core";
import { HttpService } from "../http.service";
import { SeoResponse } from "../../../models/admin/seo.model";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class SeoSettingService extends HttpService<any, SeoResponse> {

     constructor(httpClient: HttpClient, @Inject('API_URL') apiUrl: string, @Inject('API_VERSION') apiVersion: string) {
        super(httpClient, apiUrl, apiVersion, 'home-page-meta-settings');
      }
    getSeoSettings(): Observable<SeoResponse> {
    return this.getAll('get-meta-settings') as Observable<SeoResponse>;
    }
    getSeoSettingsAdmin(): Observable<SeoResponse> {
    return this.getAll('admin/get-meta-settings') as Observable<SeoResponse>;
    }

    saveSeoSettings(payload: any): Observable<any> {
      return this.update(payload, '', 'update-meta-settings');
    }
}
